/* eslint-disable react/no-unescaped-entities */
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useEffect } from 'react'

import { MainContainer } from '~/components/atoms/main-container'
import { SeoTags } from '~/components/seo-tags'
import { useTracking } from '~/providers/tracking-provider'

const Page = () => {
	const { track } = useTracking()

	// TODO: Legacy tracking, remove?
	useEffect(() => {
		track.landingPage()
	}, [track])

	return (
		<>
			<SeoTags
				title='Règlement intérieur - Cocoon Space'
				description="Règles d'utilisation de nos cocoons. Une questions à ce sujet ? Cette page est dédiée à cela."
			/>

			<MainContainer className='prose max-w-[800px]'>
				<div>
					<h1>Règlement intérieur des Cocoons</h1>

					<p>
						La philosophie de Cocoon Space s'inscrit dans le mouvement de
						l'économie partagée. Utiliser notre service, c'est adhérer aux
						valeurs d'une communauté. Nous vous demandons de respecter quelques
						règles très simples :
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Rangement</h2>

					<p>
						Pour vous garantir un environnement de travail agréable,
						l'aménagement a été réalisé avec beaucoup d'attention. Pour que
						chacun puisse bénéficier de ce confort, nous vous demandons de ne
						rien laisser sur place et de remettre les meubles en place lors de
						votre départ.
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Ponctualité</h2>

					<p>
						Pensez à ceux qui arrivent après vous et respectez vos horaires.
						Vous pouvez étendre votre réservation si besoin et que le planning
						le permet.
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Propreté</h2>

					<p>
						L'endroit se doit d'être aussi propre à votre départ qu'à votre
						arrivée, nous vous demandons de le restituer dans le même état. La
						personne qui arrive juste après vous, vous en sera reconnaissante.
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Pour les gourmands</h2>

					<p>
						La nourriture est tolérée si elle ne laisse ni trace ni odeur. Les
						espaces Cocoon Space ont pour vocation d'être des espaces de
						travail, les gourmands qui sont venus avec une collation auront la
						délicatesse de tout mettre à la poubelle lors de leur départ.
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Partage</h2>

					<p>
						Vous trouvez à disposition des stylos, des crayons, des feutres pour
						tableau blancs, et des blocs de « post-it », ces ressources ont pour
						vocation d'être utilisées sur place et d'y rester.
					</p>
				</div>

				<div>
					<h2 className='!m-0'>Savoir vivre (respect du voisinage)</h2>

					<p>
						Lorsque vous louez un Cocoon, l'espace à disposition est uniquement
						celui-ci. Vous ne pouvez pas vous installer dans les parties
						communes. Nous comptons aussi sur vous pour respecter le voisinage
						et ne pas être trop bruyant, d'autre utilisateurs travaillent à côté
						de vous.
					</p>
				</div>

				<div>
					<h1>Règlement intérieur des Desks</h1>

					<p>
						Nous vous demandons d'appliquer les règles d'utilisation qui vous
						seront données à votre arrivée dans l'espace de Coworking.
					</p>
				</div>

				<div>
					<p>Merci à vous !</p>
					<p>Nous vous souhaitons une excellente expérience !</p>
					<p>L'équipe Cocoon Space</p>
				</div>
			</MainContainer>
		</>
	)
}

export default Page

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
	props: {
		...(await serverSideTranslations(locale as string, [...defaultI18nNs])),
	},
})
